const keyRegistered = 'mock-client-registered';

export const getEnvMockVariantValue = () => {
  const MOCK_REGISTERED_VALUE = Object.freeze('');

  const defaultValue = MOCK_REGISTERED_VALUE;

  const applyValue = (item: string) => {
    return item === 'true';
  };

  const temp = MOCK_REGISTERED_VALUE;
  const value = applyValue(temp?.length ? temp : defaultValue);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return value || localStorage.getItem(keyRegistered) === 'true';
};

export const getMockClientRegistered = () => {
  let status = false;
  if (localStorage.getItem(keyRegistered) === 'true') {
    status = true;
  }

  if (getEnvMockVariantValue()) {
    status = true;
  }

  return status;
};
